export const worksMovies = [
  {
    id: "m-01",
    title: "星际归途",
    type: "movie" as const,
    year: 2024,
    region: "中国大陆",
    language: "国语",
    genres: ["科幻", "冒险", "剧情"],
    director: "陆远",
    actors: ["陈默", "林晚", "苏晓"],
    duration: "128分钟",
    rating: 8.6,
    summary:
      "一场深空航行意外将飞船卷入未知虫洞，宇航员陈默必须在燃料耗尽前找到归途，而故乡地球正等待他的最后一份信号。",
    poster:
      "https://readdy.ai/api/search-image?query=a%20lone%20astronaut%20in%20a%20white%20spacesuit%20standing%20before%20a%20swirling%20glowing%20wormhole%20in%20deep%20space%2C%20colorful%20nebula%20and%20stars%20behind%2C%20cool%20blue%20tones%20with%20warm%20orange%20rim%20light%2C%20cinematic%20movie%20poster%20art%2C%20dramatic%20lighting%2C%20rich%20color%20grading%2C%20atmospheric%20detailed%20background%2C%20professional%20film%20key%20art%2C%20vertical%20composition%2C%20high%20detail&width=600&height=900&seq=cnfilm-m01-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=a%20sleek%20futuristic%20spaceship%20drifting%20through%20a%20vast%20colorful%20nebula%2C%20a%20distant%20glowing%20planet%20on%20the%20horizon%2C%20dense%20star%20field%2C%20epic%20scale%2C%20cinematic%20film%20still%2C%20wide%20shot%2C%20epic%20atmosphere%2C%20dramatic%20volumetric%20lighting%2C%20rich%20color%20grading%2C%20ultra%20detailed%2C%20professional%20cinematography&width=1600&height=900&seq=cnfilm-m01-backdrop&orientation=landscape",
    tags: ["太空", "硬科幻", "亲情"],
    hot: true,
    updatedAt: "2024-06-18",
  },
  {
    id: "m-02",
    title: "长安夜雨",
    type: "movie" as const,
    year: 2023,
    region: "中国大陆",
    language: "国语",
    genres: ["古装", "剧情", "悬疑"],
    director: "顾清",
    actors: ["沈书", "叶楠", "周岚"],
    duration: "141分钟",
    rating: 8.9,
    summary:
      "长安城连绵夜雨中，一桩灭门旧案被重新翻开，落魄书生沈书卷入朝堂暗流，在真相与忠诚之间步步惊心。",
    poster:
      "https://readdy.ai/api/search-image?query=an%20ancient%20Chinese%20scholar%20in%20flowing%20robes%20standing%20under%20lantern%20lit%20rain%20in%20a%20Tang%20dynasty%20city%20at%20night%2C%20traditional%20architecture%2C%20moody%20teal%20and%20warm%20lantern%20glow%2C%20cinematic%20movie%20poster%20art%2C%20dramatic%20lighting%2C%20rich%20color%20grading%2C%20atmospheric%20detailed%20background%2C%20professional%20film%20key%20art%2C%20vertical%20composition%2C%20high%20detail&width=600&height=900&seq=cnfilm-m02-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=rainy%20night%20panorama%20of%20an%20ancient%20Tang%20dynasty%20capital%20city%2C%20glowing%20lanterns%20reflecting%20on%20wet%20stone%20streets%2C%20misty%20atmosphere%2C%20cinematic%20film%20still%2C%20wide%20shot%2C%20epic%20atmosphere%2C%20dramatic%20volumetric%20lighting%2C%20rich%20color%20grading%2C%20ultra%20detailed%2C%20professional%20cinematography&width=1600&height=900&seq=cnfilm-m02-backdrop&orientation=landscape",
    tags: ["权谋", "盛唐", "悬疑"],
    hot: true,
    updatedAt: "2024-05-30",
  },
  {
    id: "m-03",
    title: "深海回声",
    type: "movie" as const,
    year: 2024,
    region: "中国香港",
    language: "粤语",
    genres: ["悬疑", "惊悚", "犯罪"],
    director: "梁正",
    actors: ["何君", "郑宇"],
    duration: "116分钟",
    rating: 8.2,
    summary:
      "深海科考站接连出现无法解释的失踪事件，女警官何君潜入调查，却发现每个人都在隐瞒同一段被淹没的记忆。",
    poster:
      "https://readdy.ai/api/search-image?query=a%20woman%20detective%20in%20a%20dark%20coat%20standing%20in%20a%20dim%20underwater%20research%20station%20corridor%2C%20flickering%20lights%2C%20deep%20teal%20underwater%20ambience%2C%20suspenseful%20mood%2C%20cinematic%20movie%20poster%20art%2C%20dramatic%20lighting%2C%20rich%20color%20grading%2C%20atmospheric%20detailed%20background%2C%20professional%20film%20key%20art%2C%20vertical%20composition%2C%20high%20detail&width=600&height=900&seq=cnfilm-m03-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=interior%20of%20a%20deep%20sea%20research%20station%20with%20glowing%20instrument%20panels%2C%20dark%20water%20visible%20through%20portholes%2C%20cold%20blue%20tones%2C%20cinematic%20film%20still%2C%20wide%20shot%2C%20epic%20atmosphere%2C%20dramatic%20volumetric%20lighting%2C%20rich%20color%20grading%2C%20ultra%20detailed%2C%20professional%20cinematography&width=1600&height=900&seq=cnfilm-m03-backdrop&orientation=landscape",
    tags: ["犯罪", "心理", "反转"],
    hot: false,
    updatedAt: "2024-07-02",
  },
  {
    id: "m-04",
    title: "逐光者",
    type: "movie" as const,
    year: 2022,
    region: "中国大陆",
    language: "国语",
    genres: ["剧情", "励志", "现实"],
    director: "方野",
    actors: ["罗天成", "许晴"],
    duration: "134分钟",
    rating: 8.4,
    summary:
      "小镇青年罗天成怀揣镜头梦想闯入都市，在无数次失败与质疑中坚持拍摄，只为让平凡人的生活被世界看见。",
    poster:
      "https://readdy.ai/api/search-image?query=a%20young%20man%20holding%20a%20vintage%20film%20camera%20on%20a%20city%20rooftop%20at%20golden%20hour%2C%20warm%20sunset%20light%2C%20urban%20skyline%20behind%2C%20hopeful%20mood%2C%20cinematic%20movie%20poster%20art%2C%20dramatic%20lighting%2C%20rich%20color%20grading%2C%20atmospheric%20detailed%20background%2C%20professional%20film%20key%20art%2C%20vertical%20composition%2C%20high%20detail&width=600&height=900&seq=cnfilm-m04-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=a%20young%20photographer%20filming%20on%20a%20city%20rooftop%20at%20sunrise%2C%20warm%20golden%20light%20flooding%20the%20skyline%2C%20cinematic%20hopeful%20scene%2C%20cinematic%20film%20still%2C%20wide%20shot%2C%20epic%20atmosphere%2C%20dramatic%20volumetric%20lighting%2C%20rich%20color%20grading%2C%20ultra%20detailed%2C%20professional%20cinematography&width=1600&height=900&seq=cnfilm-m04-backdrop&orientation=landscape",
    tags: ["现实", "成长", "热血"],
    hot: false,
    updatedAt: "2024-03-11",
  },
  {
    id: "m-05",
    title: "孤城风云",
    type: "movie" as const,
    year: 2023,
    region: "中国大陆",
    language: "国语",
    genres: ["动作", "战争", "历史"],
    director: "秦戈",
    actors: ["赵烈", "孙蕾"],
    duration: "150分钟",
    rating: 8.0,
    summary:
      "边陲孤城被围三月，守将赵烈带领残兵与百姓死守城门，在断粮与背叛中书写一段悲壮的守护史诗。",
    poster:
      "https://readdy.ai/api/search-image?query=an%20armored%20ancient%20Chinese%20general%20holding%20a%20spear%20standing%20before%20a%20war%20torn%20city%20gate%2C%20smoke%20and%20embers%2C%20dramatic%20amber%20and%20dark%20red%20tones%2C%20cinematic%20movie%20poster%20art%2C%20dramatic%20lighting%2C%20rich%20color%20grading%2C%20atmospheric%20detailed%20background%2C%20professional%20film%20key%20art%2C%20vertical%20composition%2C%20high%20detail&width=600&height=900&seq=cnfilm-m05-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=epic%20siege%20of%20an%20ancient%20walled%20city%20at%20dusk%2C%20soldiers%20on%20the%20battlements%2C%20smoke%20rising%2C%20dramatic%20amber%20light%2C%20cinematic%20film%20still%2C%20wide%20shot%2C%20epic%20atmosphere%2C%20dramatic%20volumetric%20lighting%2C%20rich%20color%20grading%2C%20ultra%20detailed%2C%20professional%20cinematography&width=1600&height=900&seq=cnfilm-m05-backdrop&orientation=landscape",
    tags: ["战争", "家国", "群像"],
    hot: false,
    updatedAt: "2024-04-08",
  },
  {
    id: "m-06",
    title: "时间旅人",
    type: "movie" as const,
    year: 2024,
    region: "美国",
    language: "英语",
    genres: ["科幻", "爱情", "悬疑"],
    director: "Nolan Ford",
    actors: ["Emma Reed", "Liam Cole"],
    duration: "122分钟",
    rating: 8.7,
    summary:
      "物理学家意外掌握回溯时间的能力，为挽回一场遗憾不断重启过去，却在一次次改变中发现命运的代价。",
    poster:
      "https://readdy.ai/api/search-image?query=a%20man%20and%20woman%20reaching%20toward%20each%20other%20across%20a%20fractured%20glowing%20clock%20face%2C%20floating%20time%20fragments%2C%20warm%20and%20cool%20contrast%2C%20cinematic%20movie%20poster%20art%2C%20dramatic%20lighting%2C%20rich%20color%20grading%2C%20atmospheric%20detailed%20background%2C%20professional%20film%20key%20art%2C%20vertical%20composition%2C%20high%20detail&width=600&height=900&seq=cnfilm-m06-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=a%20sci-fi%20cityscape%20at%20twilight%20with%20glowing%20clock%20gears%20suspended%20in%20the%20sky%2C%20surreal%20time%20travel%20atmosphere%2C%20cinematic%20film%20still%2C%20wide%20shot%2C%20epic%20atmosphere%2C%20dramatic%20volumetric%20lighting%2C%20rich%20color%20grading%2C%20ultra%20detailed%2C%20professional%20cinematography&width=1600&height=900&seq=cnfilm-m06-backdrop&orientation=landscape",
    tags: ["穿越", "烧脑", "爱情"],
    hot: true,
    updatedAt: "2024-07-20",
  },
  {
    id: "m-07",
    title: "迷雾森林",
    type: "movie" as const,
    year: 2023,
    region: "新西兰",
    language: "英语",
    genres: ["奇幻", "冒险", "家庭"],
    director: "Peter Hale",
    actors: ["Mia Grant", "Owen Bell"],
    duration: "108分钟",
    rating: 7.9,
    summary:
      "少女循着失踪父亲留下的地图闯入会吞噬记忆的迷雾森林，在奇幻生物的指引下寻找回家的路。",
    poster:
      "https://readdy.ai/api/search-image?query=a%20young%20girl%20with%20a%20lantern%20walking%20into%20a%20misty%20enchanted%20forest%2C%20glowing%20mystery%20lights%20among%20tall%20trees%2C%20magical%20cool%20green%20haze%2C%20cinematic%20movie%20poster%20art%2C%20dramatic%20lighting%2C%20rich%20color%20grading%2C%20atmospheric%20detailed%20background%2C%20professional%20film%20key%20art%2C%20vertical%20composition%2C%20high%20detail&width=600&height=900&seq=cnfilm-m07-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=a%20vast%20misty%20enchanted%20forest%20at%20dawn%2C%20glowing%20lights%20between%20towering%20ancient%20trees%2C%20magical%20atmosphere%2C%20cinematic%20film%20still%2C%20wide%20shot%2C%20epic%20atmosphere%2C%20dramatic%20volumetric%20lighting%2C%20rich%20color%20grading%2C%20ultra%20detailed%2C%20professional%20cinematography&width=1600&height=900&seq=cnfilm-m07-backdrop&orientation=landscape",
    tags: ["奇幻", "成长", "家庭"],
    hot: false,
    updatedAt: "2024-02-26",
  },
  {
    id: "m-08",
    title: "末代厨神",
    type: "movie" as const,
    year: 2024,
    region: "日本",
    language: "日语",
    genres: ["喜剧", "美食", "剧情"],
    director: "佐藤健一",
    actors: ["高桥凉", "新垣美"],
    duration: "105分钟",
    rating: 8.1,
    summary:
      "落魄的传统料理传人为保住祖传老店，参加全国厨艺大赛，用一道道家常菜对抗工业化流水线的味觉冲击。",
    poster:
      "https://readdy.ai/api/search-image?query=a%20determined%20young%20Japanese%20chef%20in%20a%20traditional%20kitchen%20holding%20a%20steaming%20donburi%2C%20warm%20lantern%20light%2C%20appetizing%20food%20photography%20mood%2C%20cinematic%20movie%20poster%20art%2C%20dramatic%20lighting%2C%20rich%20color%20grading%2C%20atmospheric%20detailed%20background%2C%20professional%20film%20key%20art%2C%20vertical%20composition%2C%20high%20detail&width=600&height=900&seq=cnfilm-m08-poster&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=a%20traditional%20Japanese%20kitchen%20with%20steam%20and%20warm%20lanterns%2C%20fresh%20ingredients%20arranged%20on%20a%20wooden%20counter%2C%20cozy%20atmosphere%2C%20cinematic%20film%20still%2C%20wide%20shot%2C%20epic%20atmosphere%2C%20dramatic%20volumetric%20lighting%2C%20rich%20color%20grading%2C%20ultra%20detailed%2C%20professional%20cinematography&width=1600&height=900&seq=cnfilm-m08-backdrop&orientation=landscape",
    tags: ["美食", "治愈", "喜剧"],
    hot: false,
    updatedAt: "2024-06-05",
  },
];